import React, {useState} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './login.css';
import authService from './authService';
import Loader from '../../commonComponents/loader';
import { NotificationManager } from 'react-notifications';
import { getCookie } from '../../function';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

// Validation schema using Yup
const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string().min(6, 'Password must be at least 6 characters long').required('Password is required'),
});

const Login = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [redirectToReferrer,setRedirectToReferrer]=useState(false)
    const [passwordView, setPasswordView]=useState(false)
    const navigate = useNavigate();

    // Formik hook for handling form state and validation
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setIsLoaded(true);
            setSubmitting(true);
            try {
                // Simulate API call (replace this with your actual API call)
                let data={
                    email:values.email,
                    password:values.password
                }
                const response = await authService.getClientLogin(data);
                
                if (response) {
                    authService.authenticate(response, () => {
                        setRedirectToReferrer(true);
                        setIsLoaded(false);
                        window.location.reload();
                    });
                    resetForm();
                } else {
                    setIsLoaded(false);
                    NotificationManager.error("Please! Check Username & Password", "Input Field");
                }
            } catch (error) {
                console.error('Error during login:', error);
                // Handle error (e.g., show a message to the user)
            } finally {
                setSubmitting(false);
            }
        }
    });
   
    return (
        <div className='login d-flex justify-content-center align-items-center'>
            {isLoaded ? <Loader /> : ''}
            <div className="card">
                <div className="card-body d-flex justify-content-center align-items-center text-center">
                    <form onSubmit={formik.handleSubmit}>
                        <h5 className="card-title">Welcome to Client Login</h5>

                        <div className="form-group">
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                placeholder="Enter email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}  // For touch event
                            />
                            
                            {formik.touched.email && formik.errors.email ? (
                                <div className="text-danger form_err_msg">{formik.errors.email}</div>
                            ) : null}
                        </div>

                        <div className="form-group position-relative">
                            <input
                                type={passwordView ? "text" : "password"}
                                className="form-control"
                                id="password"
                                name="password"
                                placeholder="Password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}  // For touch event
                            />
                            <span className='paddwordView' onClick={()=>setPasswordView(!passwordView)} >
                                {
                                    passwordView ?
                                    <FaEye />:
                                    <FaEyeSlash /> 
                                }
                                {/* <FaEyeSlash /> */}
                            </span>
                            {formik.touched.password && formik.errors.password ? (
                                <div className="text-danger form_err_msg">{formik.errors.password}</div>
                            ) : null}
                        </div>

                        <button type="submit" className="btn btn-primary mt-3">Sign In</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
